<template>
  <Multiselect
    v-model="valueModel"
    label="label"
    trackBy="id"
    valueByPath="id"
    :options="propertyTypesOptions"
    :max="max"
    :returnAsSingle="returnAsSingle"
  ></Multiselect>
</template>

<script>
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import { map } from 'lodash'

export default {
    name: 'UIPropertyTypeSelect',
    components: {
        Multiselect,
    },
    props: {
        value: {
            required: true,
            type: Array,
            default: _ => [],
        },
        max: {
            required: false,
            type: Number,
            default: _ => -1,
        },
        returnAsSingle: {
            required: false,
            type: Boolean,
            default: _ => false,
        },
    },
    computed: {
        propertyTypesOptions() {
            return map(this.$store.getters.propertyTypes, pt => {
                return { id: pt.key, label: pt.name }
            })
        },
        valueModel: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
    },
}
</script>
